import { render, staticRenderFns } from "./NewOption.vue?vue&type=template&id=0c9d6306&scoped=true"
import script from "./NewOption.vue?vue&type=script&lang=js"
export * from "./NewOption.vue?vue&type=script&lang=js"
import style0 from "./NewOption.vue?vue&type=style&index=0&id=0c9d6306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d6306",
  null
  
)

export default component.exports